module.exports = __webpack_public_path__ + "img/bg.7d8aa9e1.jpg";